import { fetchData } from "@app/Helpers";

export const CAMPAIGN_STALE_TIME = 1000 * 60 * 5;
export const CAMPAIGN_CACHE_TIME = Infinity;

export function describeCampaign(ident) {
    const payload = {
        campaign: {
            ident: ident
        }
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/campaign/describe",
        payload,
        successCallback: () => { },
        controller: controller,
    });
}

export function infoCampaign(ident) {
    const payload = {
        campaign: {
            ident: ident
        }
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/campaign/info",
        payload,
        successCallback: () => { },
        controller: controller,
    });
}
